import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { COUNTDOWN_BEFORE_QUESTION_DURATION } from '../app-constants';
import * as _ from 'lodash';
import { CountdownWrapperComponent } from '../cms/common/countdown-wrapper/countdown-wrapper.component';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  animations: [
    trigger('countdown', [
      transition('* => *', [
        group([
          query(
            ':leave',
            [
              animate(
                '.2s ease-out',
                style({
                  opacity: 0,
                  transform: 'translateY(-64px) scale(.5)',
                })
              ),
            ],
            { optional: true }
          ),
          query(
            ':enter',
            [
              style({
                opacity: 0,
                transform: 'translateY(64px) scale(.5)',
              }),
              animate(
                '.2s ease-out',
                style({
                  opacity: 1,
                  transform: 'translateY(0) scale(1)',
                })
              ),
            ],
            { optional: true }
          ),
        ]),
      ]),
    ]),
  ],
  imports: [CountdownWrapperComponent, TranslateModule],
})
export class CountdownComponent implements OnInit, OnDestroy {
  countdownSubscription: Subscription;
  currentNumber: number;
  numbers: number[];
  circumference;
  dashoffset: number;
  radius = 98;
  constructor() {}

  ngOnDestroy() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.currentNumber = COUNTDOWN_BEFORE_QUESTION_DURATION;
    this.numbers = new Array(COUNTDOWN_BEFORE_QUESTION_DURATION)
      .fill(null)
      .map((_, index) => COUNTDOWN_BEFORE_QUESTION_DURATION - index);

    // const radius = 98;
    this.circumference = 2 * Math.PI * this.radius;
    this.dashoffset = 0;

    const total = COUNTDOWN_BEFORE_QUESTION_DURATION;
    this.countdownSubscription = interval(1000)
      .pipe(take(total - 1))
      .subscribe(() => {
        const currentNumber = this.currentNumber - 1;
        const remaining = currentNumber - 1;
        const progress = remaining / total;
        this.dashoffset = this.circumference * (1 - progress);
        this.currentNumber = currentNumber;
      });
  }
}
